import { STRAPI_LOCALE_TO_COUNTRY } from "../constants"

export default localizations =>
  localizations.map(({ locale, translated }) => {
    if (translated || /en-/.test(locale.toLowerCase()))
      return locale.toLowerCase()
    if (!translated && STRAPI_LOCALE_TO_COUNTRY[locale.toLowerCase()]) {
      return `en-${STRAPI_LOCALE_TO_COUNTRY[
        locale.toLowerCase()
      ].toLowerCase()}`
    }
    return locale.toLowerCase()
  })
